var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Controller, useFieldArray, } from "react-hook-form";
import { useIntl, FormattedMessage } from "react-intl";
import { Row, Col, Button, Select } from "@folio/stripes/components";
import { RecekTextField } from "../inputs";
import { PublisherContactTypeEnum } from "../../types/Api";
export var NewPublisherContactsSection = function (_a) {
    var control = _a.control, errors = _a.errors;
    var formatMessage = useIntl().formatMessage;
    var _b = useFieldArray({
        control: control,
        name: "contacts",
    }), contactFields = _b.fields, appendContact = _b.append, removeContactAtIndex = _b.remove;
    return (React.createElement(React.Fragment, null,
        contactFields.map(function (field, index) { return (React.createElement(Row, { key: field.id },
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".type"), render: function (_a) {
                        var _b, _c, _d, _e, _f;
                        var field = _a.field;
                        return (React.createElement(Select, __assign({}, field, { autoComplete: "off", label: formatMessage({
                                id: "ui-br-legaldeposits.publishers.contacts.type",
                            }), error: typeof ((_c = (_b = errors.contacts) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.type) === "object"
                                ? (_f = (_e = (_d = errors.contacts) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.type) === null || _f === void 0 ? void 0 : _f.message
                                : undefined, dataOptions: [
                                {
                                    value: "",
                                    label: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.contacts.type.default",
                                    }),
                                },
                                {
                                    value: "EMAIL",
                                    label: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.contacts.type.email",
                                    }),
                                },
                                {
                                    value: "WEB",
                                    label: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.contacts.type.web",
                                    }),
                                },
                                {
                                    value: "PHONE",
                                    label: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.contacts.type.phone",
                                    }),
                                },
                                {
                                    value: "DATA_BOX",
                                    label: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.contacts.type.dataBox",
                                    }),
                                },
                            ] })));
                    } })),
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".value"), render: function (_a) {
                        var _b, _c, _d;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-legaldeposits.publishers.contacts.value", error: (_d = (_c = (_b = errors.contacts) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.message })));
                    } })),
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".info"), render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { value: (_b = field.value) !== null && _b !== void 0 ? _b : undefined, autoComplete: "off", labelId: "ui-br-legaldeposits.publishers.contacts.info" })));
                    } })),
            React.createElement(Col, { xs: 12 },
                React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeContactAtIndex(index); } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.contacts.button.delete" }))))); }),
        React.createElement(Button, { onClick: function () {
                return appendContact({
                    id: "",
                    type: PublisherContactTypeEnum.EMAIL,
                    value: "",
                }, { shouldFocus: false });
            } },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.contacts.button.add" }))));
};
